import { Component, Inject } from '@angular/core';

import get from 'lodash/get';

import { ISitemap, SITEMAP } from 'pbc.angular';
import { ISorterConfig } from 'pbc.types';

import { TemplatesQuerySorterConfig } from 'fa-kt.types';
import { TemplatesService } from '../service';

@Component({
  selector: 'fa-kt-templates-sorter',
  templateUrl: './templates-sorter.component.html',
  styleUrls: ['./templates-sorter.component.css'],
})
export class TemplatesSorterComponent {
  TemplatesSorterConfig: ISorterConfig;

  constructor(
    @Inject(SITEMAP) private sitemap: ISitemap,
    public templates: TemplatesService,
  ) {
    this.TemplatesSorterConfig = TemplatesQuerySorterConfig.map((filter) => ({ ...filter, title: get(sitemap, filter.title, filter.title) as string }));
    /* << update    */
    /*    update >> */
  }
}
